<template>
  <div class="row noticia">
    <div class="small-12 medium-5 large-4 columns">
        <div class="box box1">
          <img v-if="imagem.length > 0" :src="imagem" style="height: 260px" />
          <div class="titlecontainer"
               v-if="imagem.length == 0"
               :class="{[colorClass]: imagem.length == 0}">
            <p>{{titulo}}</p>
          </div>
        </div>
    </div>
    <div class="small-12 medium-7 large-8 columns">
      <h1>{{titulo}}</h1>
      <p v-html="corpo"></p>
      <SaberBotao
          :border-color="btnColor"
          :background-color="btnColor"
          @click="goToDestaque"></SaberBotao>
    </div>
  </div>
</template>

<script>
import SaberBotao from './botao';

export default {
  name: "noticiaDep",
  props:["titulo","corpo","imagem","url","colorClass"],
  components: {
    SaberBotao
  },
  inject:["secundaryColors"],
  data(){
    return {
      btnColor: ""
    }
  },
  created() {
    this.btnColor = this.secundaryColors[this.$store.state.departamento.Faculdade.name];
  },
  methods:{
    goToDestaque(){
      window.location = this.url;
    }
  }
}


</script>

<style scoped>

.noticia h1 {
  font-family: "Montserrat Semibold";
  font-size: 20px;
  color: /*#2c2b2b*/#454648;
  padding-bottom: 5px;
}

.noticia p {
  font-family: Montserrat;
  font-size: 15px;
  color: #454648;
  padding-bottom: 10px;
}

.noticia {
  padding-bottom: 30px;
}

.box{
  position: relative;
  border-radius: 8px;
}

.box:hover{
  cursor: pointer;
}

.box:after{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0);
  transition: all .6s linear;
  content:"";
  border-radius: 8px;
}

.box:hover:after{
  background: rgba(0,0,0,.35);
  transition: all .6s linear;
}

.box img {
  width: 100%;
  height: 100%;
}

.box .titlecontainer{
  height: 260px;
  position: relative;
  border-radius: 8px;
}

.box p{
  color: white;
  transition: opacity .6s;
  font-family: Montserrat;
  font-size: 25px;
  text-align: center;
  position: absolute;
  top: 20%;
  width: 100%;
  z-index: 2;
}

.box1 img {
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.noticia .columns:nth-child(2) {
  padding-left: 30px;
  padding-top: 10px;
}







/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {




}


/*Responsive - ipad*/
@media (max-width: 1025px) {

  .noticia .columns:nth-child(2) {
    padding-left: 15px;
    padding-top: 4px;
  }

  .noticia h1 {
    font-size: 16px;
    padding-bottom: 0px;
  }

  .noticia p {
    font-size: 14px;
    padding-bottom: 5px;
  }





}

/*Responsive - iphone*/
@media (max-width: 767px) {
  .box {
    padding-left: 15px;
  }

  .box:after{
    left: 15px;
  }

  .noticia .columns:nth-child(2) {
    padding-left: 30px;
  }

  .box .titlecontainer{
    height: 120px;
  }

  .box1 img {
    height: 120px!important;
  }

  .noticia h1 {
    font-size: 15px;
    margin-bottom: 10px;
    margin-top: 15px;
  }

  .noticia p {
    font-size: 13px;
    padding-bottom: 0px;
  }

  .box {
    padding-left: 0px;
  }

  .noticia .columns:nth-child(2) {
    padding-left: 20px;
    padding-right: 20px;
  }

  .noticia {
    padding-bottom: 20px;
  }

  .box:hover:after {
    display: none;
  }








}







</style>